export enum EReportsChartKeys {
  LATEST_TRANSACTIONS = "latest-transactions-chart",
  MONTHLY_TRANSACTIONS = "monthly-transactions-chart",
  CATEGORY_TRANSACTIONS = "category-transactions-chart",
  CLIENT_PROVIDER_TRANSACTIONS = "client-provider-transactions-chart",
  PAYMENT_METHOD_TRANSACTIONS = "payment-methods-chart",
  STATUS_TRANSACTIONS = "status-transactions-chart",
}
